import { render, staticRenderFns } from "./FreestyleCanvasContent.v2.vue?vue&type=template&id=5194c2f5&scoped=true&"
import script from "./FreestyleCanvasContent.v2.vue?vue&type=script&lang=js&"
export * from "./FreestyleCanvasContent.v2.vue?vue&type=script&lang=js&"
import style0 from "./FreestyleCanvasContent.v2.vue?vue&type=style&index=0&id=5194c2f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194c2f5",
  null
  
)

export default component.exports